import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'activate:editor': () => import('./components/activate'),
        'plugin:setting': () => import('./components/setting'),
    }
});
